/**
 * Returns the best single-line display name for a plant record.
 *
 * Priority: common_name → trade_name (with bare sp. suppressed) → genus + species → specimen_id
 *
 * Cultivar names are already embedded in the species string with single quotes,
 * so they appear naturally in the genus+species fallback.
 */
export function plantDisplayName(plant) {
  if (!plant) return '';
  if (plant.common_name) return plant.common_name;
  const genus = plant.genus || '';
  const species = plant.species || '';
  const trade = plant.trade_name || '';
  if (trade) {
    const botanical = species !== 'sp.' ? [genus, species].filter(Boolean).join(' ') : genus;
    return [botanical, trade].filter(Boolean).join(' ');
  }
  return [genus, species].filter(Boolean).join(' ') || plant.specimen_id || '';
}
